import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import CloseIcon from "@material-ui/icons/Close";
import { TokenUtils } from "../shared/utils/TokenUtils";
import { moduleForLocation, modulosDoFlutuante, acessoLiberado, isCoarsePointer } from "./repondeur-utils";
import useRepondeur from "./use-repondeur";
import ChatWindow from "./chat-window";
import roboResponde from "./img/robo-conecta-responde.svg";
import "./repondeur.css";

const RepondeurFlutuante = ({ userSession }) => {
	const location = useLocation();
	const [aberto, setAberto] = useState(false);
	const [jaAbriu, setJaAbriu] = useState(false);
	const [contextoBff, setContextoBff] = useState(undefined);
	const painelRef = useRef(null);
	const chat = useRepondeur();
	const moduloAnteriorRef = useRef(null);
	const moduloAtual = moduleForLocation(location, moduloAnteriorRef.current);
	const { clearVisual, carregarContexto } = chat;
	const podeConsultar = !!moduloAtual && !!userSession && TokenUtils.hasModuloRepondeur();

	useEffect(() => {
		if (!podeConsultar || contextoBff !== undefined) return;
		let ativo = true;
		carregarContexto().then(dados => {
			if (ativo) setContextoBff(dados || null);
		});
		return () => {
			ativo = false;
		};
	}, [podeConsultar, contextoBff, carregarContexto]);

	// o histórico vive enquanto o usuário permanece no módulo, mesmo com o chat
	// fechado; trocar de módulo descarta a conversa visual
	useEffect(() => {
		if (moduloAnteriorRef.current !== moduloAtual) {
			moduloAnteriorRef.current = moduloAtual;
			clearVisual();
			setAberto(false);
			setJaAbriu(false);
		}
	}, [moduloAtual, clearVisual]);

	useEffect(() => {
		if (!aberto || !painelRef.current) return;
		const campo = painelRef.current.querySelector("textarea");
		if (campo && !isCoarsePointer()) campo.focus();
	}, [aberto]);

	const abrir = () => {
		setAberto(true);
		setJaAbriu(true);
	};

	const habilitado =
		podeConsultar &&
		contextoBff !== undefined &&
		acessoLiberado(contextoBff) &&
		Array.isArray(userSession.modulos) &&
		userSession.modulos.includes(moduloAtual) &&
		modulosDoFlutuante(contextoBff).includes(moduloAtual);

	if (!habilitado) return null;

	return (
		<div className="repondeur-flutuante">
			<div
				ref={painelRef}
				className={"repondeur-flutuante-painel" + (aberto ? "" : " fechado")}
				aria-hidden={!aberto}
			>
				<div className="repondeur-flutuante-cabecalho">
					<img src={roboResponde} alt="" />
					<span>Conecta Responde</span>
					<button type="button" onClick={() => setAberto(false)} aria-label="Fechar chat">
						<CloseIcon fontSize="inherit" />
					</button>
				</div>
				<div className="repondeur-flutuante-corpo">
					{jaAbriu && <ChatWindow chat={chat} />}
				</div>
			</div>
			<button
				type="button"
				className="repondeur-flutuante-botao"
				onClick={aberto ? () => setAberto(false) : abrir}
				aria-expanded={aberto}
				aria-label={aberto ? "Fechar chat Conecta Responde" : "Abrir chat Conecta Responde"}
			>
				<img src={roboResponde} alt="" />
			</button>
		</div>
	);
};

export default RepondeurFlutuante;
